import { useEffect, useRef, useState } from 'react';

const theoreticalSessions = [
  {
    no: 1,
    speaker: 'PROF.DR.EZHER DAYISOYLU',
    topic: 'ANINDA İMPLANTOLOJİDE YÜZEY MODİFİKASYONU',
  },
  {
    no: 2,
    speaker: 'DT.SİNAN EMRE ŞEKERCİ',
    topic: 'ESTETİK DİŞ HEKİMLİĞİNDE BAŞARININ PÜF NOKTALARI',
  },
  {
    no: 3,
    speaker: 'DT.EMRECAN EREN',
    topic: 'HEKİMLİKTE SÜRDÜRÜLEBİLİR BAŞARI: DİJİTAL DİŞ HEKİMLİĞİNE PLANLI GEÇİŞ',
  },
  {
    no: 4,
    speaker: 'DR.FATİH RASİM',
    topic: 'ANTERİOR BÖLGEDE BİYOMİMETİK ALGORİTMA: KOMPOZİT LAMİNE, DİASTEMA VE TRAVMA YÖNETİMİ',
  },
  {
    no: 5,
    speaker: 'DT.İBRAHİM ALCU',
    topic: 'AĞIZ İÇİ TARAYICILAR VE TARAMA TEKNİKLERİ',
  },
  {
    no: 6,
    speaker: 'DOÇ.DR.AYFER ATAV & DR.EMRE ÖVSAY',
    topic: 'RISING: ENDODONTİK ŞEKİLLENDİRMEDE YENİ BİR EVRİM',
  },
];

const TheoreticalSessions = () => {
  const [isHeaderVisible, setIsHeaderVisible] = useState(false);
  const [visibleRows, setVisibleRows] = useState<number[]>([]);
  const headerRef = useRef<HTMLDivElement>(null);
  const tableRef = useRef<HTMLDivElement>(null);
  const mobileRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Hemen tüm satırları göster (fallback)
    const allIndexes = theoreticalSessions.map((_, i) => i);
    setIsHeaderVisible(true);
    setVisibleRows(allIndexes);

    const headerObserver = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setIsHeaderVisible(true); },
      { threshold: 0 }
    );
    const tableObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          theoreticalSessions.forEach((_, index) => {
            setTimeout(() => setVisibleRows((prev) => [...prev, index]), index * 100);
          });
        }
      },
      { threshold: 0 }
    );

    if (headerRef.current) headerObserver.observe(headerRef.current);
    if (tableRef.current) tableObserver.observe(tableRef.current);
    if (mobileRef.current) tableObserver.observe(mobileRef.current);

    return () => { headerObserver.disconnect(); tableObserver.disconnect(); };
  }, []);

  return (
    <section className="py-12 md:py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div ref={headerRef} className="flex items-center gap-4 mb-8 md:mb-10">
          <div
            className={`w-1.5 h-12 md:h-14 bg-gradient-to-b from-primary to-accent rounded-full transition-all duration-700 ${
              isHeaderVisible ? 'opacity-100 scale-y-100' : 'opacity-0 scale-y-0'
            }`}
            style={{ transformOrigin: 'top' }}
          />
          <div>
            <div
              className={`inline-flex items-center gap-2 px-3 py-1 bg-primary/10 rounded-full mb-2 transition-all duration-700 delay-100 ${
                isHeaderVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
              }`}
            >
              <i className="ri-presentation-line text-primary text-sm" />
              <span className="text-primary font-semibold text-xs tracking-widest uppercase">Bilimsel Program</span>
            </div>
            <h2
              className={`font-display text-2xl md:text-4xl font-bold text-primary transition-all duration-700 delay-200 ${
                isHeaderVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'
              }`}
            >
              Teorik Oturumlar
            </h2>
          </div>
        </div>

        {/* DESKTOP TABLE */}
        <div ref={tableRef} className="hidden md:block rounded-2xl overflow-hidden shadow-xl border border-gray-100">
          <div className="grid grid-cols-[60px_1fr_2fr] bg-gradient-to-r from-primary to-primary-light text-white">
            <div className="px-6 py-4 text-sm font-bold tracking-wider uppercase text-center">S.NO</div>
            <div className="px-6 py-4 text-sm font-bold tracking-wider uppercase border-l border-white/20">KONUŞMACI</div>
            <div className="px-6 py-4 text-sm font-bold tracking-wider uppercase border-l border-white/20">KONU BAŞLIĞI</div>
          </div>
          {theoreticalSessions.map((session, index) => (
            <div
              key={session.no}
              className={`grid grid-cols-[60px_1fr_2fr] transition-all duration-700 hover:bg-accent/5 group ${
                index % 2 === 0 ? 'bg-white' : 'bg-gray-50/60'
              } ${visibleRows.includes(index) ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8'}`}
            >
              <div className="px-6 py-5 flex items-center justify-center">
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-primary/10 text-primary font-bold text-sm group-hover:bg-accent group-hover:text-white transition-all duration-300">
                  {session.no}
                </span>
              </div>
              <div className="px-6 py-5 border-l border-gray-100 flex items-center">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-accent flex-shrink-0" />
                  <span className="font-semibold text-primary text-sm leading-snug">{session.speaker}</span>
                </div>
              </div>
              <div className="px-6 py-5 border-l border-gray-100 flex items-center">
                <p className="text-gray-700 text-sm leading-relaxed font-medium">{session.topic}</p>
              </div>
            </div>
          ))}
        </div>

        {/* MOBILE CARDS */}
        <div ref={mobileRef} className="md:hidden flex flex-col gap-4">
          {theoreticalSessions.map((session, index) => (
            <div
              key={session.no}
              className={`rounded-xl border border-gray-100 shadow-md bg-white overflow-hidden transition-all duration-500 ${
                visibleRows.includes(index) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
            >
              <div className="bg-gradient-to-r from-primary to-primary-light px-4 py-2 flex items-center gap-2">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-white/20 text-white font-bold text-xs">
                  {session.no}
                </span>
                <span className="text-white/80 text-xs font-semibold tracking-widest uppercase">Teorik Oturum</span>
              </div>
              <div className="p-4">
                <div className="flex items-start gap-2 mb-3">
                  <div className="w-2 h-2 rounded-full bg-accent flex-shrink-0 mt-1.5" />
                  <span className="font-bold text-primary text-sm leading-snug">{session.speaker}</span>
                </div>
                <div className="flex items-start gap-2">
                  <i className="ri-file-text-line text-accent text-sm flex-shrink-0 mt-0.5" />
                  <p className="text-gray-700 text-sm leading-relaxed">{session.topic}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 flex items-center gap-2 text-gray-400 text-xs">
          <i className="ri-information-line" />
          <span>Teorik oturumlar tüm katılımcılara açıktır.</span>
        </div>
      </div>
    </section>
  );
};

export default TheoreticalSessions;
